import Vue from 'vue'

import UiModal from '@common/component/ui-modal/ui-modal.common';
import UiSearchFrom from '@common/component/ui-search-form/ui-search-form.common.vue';
import UiForm from '@common/component/ui-form/ui-form.common';
import UiDetail from '@common/component/ui-detail/ui-detail.common';
import UiTable from '@common/component/ui-table/ui-table.common';

// 弹窗
Vue.component('UiModal',UiModal)
// 搜索用表单
Vue.component('UiSearchFrom',UiSearchFrom)
// 正常表单
Vue.component('UiForm',UiForm)
// 详情
Vue.component('UiDetail',UiDetail)
// 表格
Vue.component('UiTable',UiTable)